'use client';

import { useEffect, useMemo, useState } from 'react';

export function Line() {
  const [documentLength, setDocumentLength] = useState(0);
  const [viewportWidth, setViewportWidth] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);

  useEffect(() => {
    let resizeTimer: ReturnType<typeof setTimeout>;
    const updateDimensions = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const homeWrapper = document.getElementById('home-wrapper');
        if (homeWrapper) {
          setDocumentLength(homeWrapper.offsetHeight + 100);
        }
        setViewportWidth(window.innerWidth);
      }, 300);
    };
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollOffset(window.scrollY);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function generateWavePath(height: number, width: number) {
    let path = `M ${width / 2},0`;
    let y = 0;
    let direction = 1;

    while (y < height) {
      let waveLen = 500 + Math.random() * 400;
      if (y + waveLen > height) waveLen = height - y;
      const midY = y + waveLen / 2;
      const amplitude = width / 6; // Scales the wave amplitude with width
      const ctrlX =
        direction > 0
          ? width / 2 + amplitude + Math.random() * (amplitude / 5)
          : width / 2 - amplitude + Math.random() * (amplitude / 5);

      path += ` S ${ctrlX},${midY} ${width / 2},${y + waveLen}`;
      y += waveLen;
      direction *= -1;
    }

    return path;
  }

  const waveHeight = useMemo(() => {
    let wh = documentLength || 300;
    if (viewportWidth > 1080) {
      wh -= 300;
    }
    return Math.max(wh, 600);
  }, [documentLength, viewportWidth]);

  const svgWidth = useMemo(() => {
    return Math.max(300, viewportWidth > 600 ? viewportWidth - 40 : viewportWidth - 20);
  }, [viewportWidth]);

  const pathD = useMemo(() => generateWavePath(waveHeight, svgWidth), [waveHeight, svgWidth]);

  return (
    <svg
      viewBox={`0 0 ${svgWidth} ${waveHeight}`}
      preserveAspectRatio="none"
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: `${svgWidth}px`,
        zIndex: 50,
      }}
      id="home-line"
    >
      <path
        d={pathD}
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="4"
        strokeDasharray="20 20" // Increased dash length
        strokeDashoffset={-scrollOffset / 2} // Offset dashes based on scroll position
        fill="none"
      />
    </svg>
  );
}
